import Box from '@mui/material/Box'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { updateFieldValue } from '../../../../../../store/actions/analytics.actions'
import SelectorStudentClass from '../Current/SelectorStudentClass/SelectorStudentClass'
import MarkignLegend from '../Current/MarkingLegend/MarkignLegend'
import ViewSelector from '../Current/ViewSelector/ViewSelector'
import Module from '../../../../../layout/Module'
import LoadingSpinner from '../../../../../Loading/LoadingSpinner'
import { useLocation, useParams } from 'react-router-dom'
import { useCallback } from 'react'
import useFetchData from '../../../../../../hooks/useFetchData'
import isEmpty from 'lodash/isEmpty'
import { Typography } from '@mui/material'
import Filter from './Filter/Filter'
import List from './List/List'
import ByStudent from '../Current/ByStudent/ByStudent'
import ByClasses from '../Current/ByClasses/ByClasses'

const History = ({ isLoading }) => {
  const roles = useSelector((state) => state?.session.user.roles?.map((r) => r.id))
  const { studentId } = useParams()
  const { isLoading: isLoadingUser, data: user } = useFetchData('auth/profile')

  const dispatch = useDispatch()
  const history = useSelector((state) => state?.analytics?.analyticsCurriculum?.history || null)
  const selected = useSelector((state) => state?.analytics?.analyticsCurriculum?.selectedHistory || null)
  const selectorState = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.selectorHistory || 'filter-by-student'
  )
  const byLoading = useSelector((state) => state?.analytics?.analyticsCurriculum?.byLoadingHistory || false)
  const marking = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.datasets?.data?.data?.marking || []
  )

  useEffect(() => {
    if (roles.some((role) => ['Parent', 'Student'].includes(role))) {
      dispatch(updateFieldValue('analyticsCurriculum', 'selectorHistory', 'filter-by-student'))
    } else if (roles.length === 1 && roles[0] === 'Teacher') {
      dispatch(updateFieldValue('analyticsCurriculum', 'selectorHistory', 'filter-by-classes'))
    } else {
      dispatch(
        updateFieldValue('analyticsCurriculum', 'selectorHistory', selectorState || 'filter-by-student')
      )
    }
  }, [])

  const setStudentSelected = (value) => {
    dispatch(updateFieldValue('analyticsCurriculum', 'selectedHistory', value))
  }

  const loadStudent = useCallback(async () => {
    if (isEmpty(selected) && user) {
      if (user.roles.some((role) => role.id === 'Student')) {
        setStudentSelected({
          ...user,
          _id: user._id || user.userId,
          studentId: user.userId
        })
      }

      if (user.roles.some((role) => role.id === 'Parent')) {
        if (user.children?.length > 0) {
          const student = user.children.find((child) => child._id === studentId)
          if (student) {
            setStudentSelected(student)
          }
        }
      }
    }
  }, [user, selected])

  useEffect(() => {
    loadStudent()
  }, [loadStudent])
  return (
    <>
      <Module.BodyHeader
        gap={0}
        className='border-b border-b-2 border-primary flex justify-start items-center relative'
        py={2}
        px={0}
      >
        <div className='bg-primary max-w-300px min-w-300px h-16  border-r border-2 border-muted flex justify-start items-center '>
          <Typography className='text-primary-foreground px-4 text-lg font-bold'>History</Typography>
        </div>
        <div className='relative h-16 flex justify-start items-center gap-2'>
          <ViewSelector
            isLoading={isLoading || byLoading}
            disabled={!history}
            value={selectorState}
            onChange={(value) => {
              dispatch(updateFieldValue('analyticsCurriculum', 'selectorHistory', value))
              dispatch(updateFieldValue('analyticsCurriculum', 'selectedHistory', null))
              dispatch(updateFieldValue('analyticsCurriculum', 'byStudent', []))
              dispatch(updateFieldValue('analyticsCurriculum', 'byClasses', []))
            }}
          />
          <div
            className='flex justify-start items-center absolute top-0px bottom-0px right-0'
            style={{
              left: roles.some((role) => ['Parent', 'Student'].includes(role)) ? '0' : 'calc(150px + 2rem)'
            }}
          >
            <SelectorStudentClass
              type={selectorState === 'filter-by-student' ? 'analyticsUsers' : 'analyticsClasses'}
              onChange={setStudentSelected}
              isLoading={byLoading || isLoading}
              selected={selected}
              selectorState={selectorState}
              disabled={!history}
              view='history'
            />
          </div>
        </div>
      </Module.BodyHeader>
      <Module.BodyContainer classNameWrapper='overflow-auto' px={0} py={0}>
        <div className='max-w-300px min-w-300px border-r border-2 border-muted h-full'>
          <Box className='px-2 py-2 sticky top-0px inset-x-0 h-6 bg-background flex items-center justify-start gap-4 z-12 border-b border-b-2 border-primary'>
            <Filter />
          </Box>
          <Box>
            <List />
          </Box>
        </div>
        <div className='absolute top-0px bottom-0px right-0 overflow-auto' style={{ left: 302 }}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              {history && (
                <>
                  <Box className='px-2 py-2 sticky top-0px inset-x-0 h-6 bg-background flex items-center justify-start gap-4 z-10 border-b border-b-2 border-primary'>
                    <MarkignLegend marking={history?.data?.marking || []} />
                  </Box>
                  {selectorState === 'filter-by-student' && (
                    <ByStudent isLoading={byLoading || isLoading} view='history' />
                  )}
                  {selectorState === 'filter-by-classes' && (
                    <ByClasses isLoading={byLoading || isLoading} view='history' />
                  )}
                </>
              )}
            </>
          )}
        </div>
      </Module.BodyContainer>
    </>
  )
}

export default History
